module.exports = __webpack_public_path__ + "img/central-vs-blockchain.7abce567.gif";